<template>
  <div class="text-center text-info my-2">
    <BSpinner class="align-middle mr-2"></BSpinner>
    <strong>{{ infoText }}</strong>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { BSpinner } from "bootstrap-vue-next";

export default defineComponent({
  name: "GridLoading",
  components: {
    BSpinner
  },
  props: {
    infoText: {
      type: String,
      default: "Loading..."
    }
  }
});
</script>

<style scoped>
.text-info {
  color: #0054a6 !important;
}
</style>
